import { useRef } from 'react'

let uniqueId = 0
const getUniqueId = () => uniqueId++

export function useComponentId(prefix?: string) {
  const idRef = useRef(getUniqueId())
  return `${prefix ? `${prefix}-` : ''}${idRef.current.toString()}`
}
